import {
  CREDIT_LIMIT_FETCH_SUCCESS,
} from '../actionTypes';

let initialState = {
  base_potential_credit_limit: 0,
  credit_remaining: 0,
  credit_used: 0,
  max_potential_credit_limit: 0,
  setup_step: 1,
}

export default function creditLimit(state = initialState, action) {
  switch(action.type) {
    case CREDIT_LIMIT_FETCH_SUCCESS:
      return {...state, ...action.payload};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/CreditLimit/reducers/creditLimit.js